import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { FF2, TextInput, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const IDNumber = () => {
  const { control } = useFormContext<SarEdit>()
  const type = useWatch({ control, name: 'institutionContactInfo.idType' })

  return (
    <Controller
      name="institutionContactInfo.idNumber"
      control={control}
      rules={{
        validate: (value) => (type?.length > 0 ? Validators.required.field(value) : undefined)
      }}
      render={({ field }) => (
        <FF2 required={type?.length > 0} label="ID Number" field={field} input={(props) => <TextInput {...props} />} />
      )}
    />
  )
}
